import { FontWeight, Tag, TagSize } from '@leland-dev/leland-ui-library';
import Image from 'next/image';
import { type FC } from 'react';

import trophyImage from '../../assets/images/trophy.png';

interface SuperCoachTagProps {
  isLarge?: boolean;
}

export const SuperCoachTag: FC<SuperCoachTagProps> = ({ isLarge }) => (
  <Tag
    text="Supercoach"
    size={isLarge ? TagSize.LARGE : TagSize.SMALL}
    fontWeight={FontWeight.NORMAL}
    CustomLeftIcon={() => (
      <Image
        src={trophyImage}
        alt="Super Coach"
        width={isLarge ? 16 : 14}
        height={isLarge ? 16 : 14}
        className={`${isLarge ? 'size-4' : 'size-3.5'}`}
      />
    )}
  />
);
